import simpleParallax from 'simple-parallax-js';
console.log(simpleParallax);


const images = document.querySelectorAll('.image img');

new simpleParallax(images);